<template>
  <div class="StdImage">
    <img class="StdImage__image" :src="src" :alt="alt" />
  </div>
</template>

<script>
import { StdButton } from './../StdButton'
export default {
  components: {
    StdButton,
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    identifier: {
      type: Number,
      default: 0
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    onDeleteImage() {
      this.$store.commit('REMOVE_CHAPTER_CONTENT', this.identifier)
    }
  }
}
</script>

<style scoped>
.StdImage {
  padding: 26px;
  position: relative;
  width: 100%;
}

.StdImage__image {
  height: auto;
  max-width: 100%;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/StdImage/StdImage.vue